export const componentOptions = {
  'Recent Order History': {
    locked: {
      xPos: 0,
      yPos: 2,
    },
  },
  welcomeMessage: {
    locked: {
      xPos: 0,
      yPos: 1,
    },
  },
  'Hero Carousel': {
    locked: {
      xPos: 0,
      yPos: 0,
    },
  },
  'Private Label Credit Card': {
    locked: {
      xPos: 0,
      yPos: 3,
    },
  },
  OnlineWorkshops: {
    sizes: {
      minWidthMedium: {
        min: 6,
        max: 12,
      },
      minWidthLarge: {
        min: 4,
        max: 4,
      },
    },
  },
  'Top Savings for You': {
    sizes: {
      minWidthMedium: {
        min: 12,
        max: 12,
      },
      minWidthLarge: {
        min: 12,
        max: 12,
      },
    },
  },
  StoreDetails: {
    sizes: {
      minWidthMedium: {
        min: 6,
        max: 12,
      },
      minWidthLarge: {
        min: 4,
        max: 4,
      },
    },
  },
  SpecialBuyOfTheDay: {
    sizes: {
      minWidthMedium: {
        min: 6,
        max: 12,
      },
      minWidthLarge: {
        min: 4,
        max: 4,
      },
    },
  },
  'Todays Recommendations for You': {
    sizes: {
      minWidthMedium: {
        min: 6,
        max: 12,
      },
      minWidthLarge: {
        min: 8,
        max: 12,
      },
    },
  },
  'Sponsored Products': {
    sizes: {
      minWidthMedium: {
        min: 12,
        max: 12,
      },
      minWidthLarge: {
        min: 12,
        max: 12,
      },
    },
  },
};
